<div class="container header-title">
    <div class="container">
        <h1>Class Details</h1>
    </div>
</div>

@if (viewModel$ | async; as viewData) {

    <div class="container">

    @if (classLoading$ | async) {
        <ngx-skeleton-loader appearance="line" count="20"></ngx-skeleton-loader>
    } @else {

        @if (viewData.classDetail) {

            <div class="container">

                <div class="header">
                    <div class="back-link">
                        <a [routerLink]="['/data-lookup', 'class']"><mat-icon>arrow_back</mat-icon> Back to Class List</a>
                    </div>
                    <div class="buttons">
                        <app-additional-info 
                            [additionalInfoFields]="additionalInfoFields" 
                            contextKey="Class"
                            (fieldSelected)="onFieldSelected($event)" />
                        <ng-container *ngIf="!isExporting; else loadingExport">
                        <button tdoe-button size="large" (click)="export(viewData.classDetail.id!, viewData.selectedCategories)">Export</button>
                        </ng-container>
                        <ng-template #loadingExport>
                        <div class="progress-bar">
                            <div class="progress-text">Exporting...</div>
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </div>
                        </ng-template>
                    </div>
                </div>

                <div mat-accordion class="mat-accordion">
                    <mat-expansion-panel expanded>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Class Section Profile
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="data-list">
                            <div class="field">
                                <span class="name">Primary District</span>
                                <span class="value">{{viewData.classDetail.primaryDistrict}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Primary School</span>
                                <span class="value">{{viewData.classDetail.primarySchool}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Course Type</span>
                                <span class="value">{{viewData.classDetail.courseType}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Course Code</span>
                                <span class="value">{{viewData.classDetail.courseCode}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Local Class Number</span>
                                <span class="value">{{viewData.classDetail.localClassNumber}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Section Identifier</span>
                                <span class="value">{{viewData.classDetail.sectionIdentifier}}</span>
                            </div>
                            <div class="field course-desc">
                                <span class="name">Course Description</span>
                                <span class="value">{{viewData.classDetail.courseDescription}}</span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>

                <div mat-accordion class="mat-accordion">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Class Section Detail
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="data-list">
                            <div class="field">
                                <span class="name">Class Begin Date</span>
                                <span class="value">{{viewData.classDetail.classStartDate | date}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Class End Date</span>
                                <span class="value">{{viewData.classDetail.classEndDate | date}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Class Period Name</span>
                                <span class="value">{{viewData.classDetail.classPeriod}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Class Period Duration</span>
                                <span class="value">{{viewData.classDetail.classPeriod?.periodDuration}}</span>
                            </div>
                            <div class="field course-desc">
                                <span class="name">Class type</span>
                                <span class="value">{{viewData.classDetail.classType}}</span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>

                <div mat-accordion class="mat-accordion">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Course Attributes
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="data-list">
                            <div class="field">
                                <span class="name">Honor Flag</span>
                                <span class="value">{{viewData.classDetail.honorFlag}}</span>
                            </div>
                            <div class="field">
                                <span class="name">State Dual Credit</span>
                                <span class="value">{{viewData.classDetail.stateDualCredit ?? false | boolDisplay: 'Yes' : 'No' }}</span>
                            </div>
                            <div class="field">
                                <span class="name">Local Dual Credit</span>
                                <span class="value">{{viewData.classDetail.localDualCredit ?? false | boolDisplay: 'Yes' : 'No'}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Dual Enrollment</span>
                                <span class="value">{{viewData.classDetail.dualEnrollment ?? false | boolDisplay: 'Yes' : 'No'}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Post Secondary Institution</span>
                                <span class="value">{{viewData.classDetail.postSecondaryInstitution}}</span>
                            </div>
                            <div class="field">
                                <span class="name">CTE Program Service</span>
                                <span class="value">{{viewData.classDetail.cteProgramService}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Classification of Course</span>
                                <span class="value">{{viewData.classDetail.classification}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Teaching Method</span>
                                <span class="value">{{viewData.classDetail.teachingMethod}}</span>
                            </div>
                            <div class="field">
                                <span class="name">Test Window</span>
                                <span class="value">{{viewData.classDetail.testWindow}}</span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>

                @if (viewData.staffCategory) {

                    @if (staffVM$ | async; as vm) {

                        <div class="mat-accordion">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>

                                    <mat-panel-title>
                                        <span>Staff (</span>

                                        @if (staffLoading()) {

                                            <span>Loading...</span>

                                        } @else {

                                            <span [innerText]="vm.totalRecords | number"></span>

                                        }

                                        <span>)</span>
                                    </mat-panel-title>

                                </mat-expansion-panel-header>
                                <div class="sub-section">

                                    @if (staffLoading()) {

                                        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                    
                                    } @else {

                                        <div class="scrollinator">

                                            <mat-table [dataSource]="vm.data ?? []">

                                                @for (col of viewData.staffCategory.fields;track col) {

                                                    <ng-container [matColumnDef]="strip(col.key)">
                                                        <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                                        <mat-cell *matCellDef="let item">
                                                            {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                                        </mat-cell>
                                                    </ng-container>

                                                }

                                                <mat-header-row *matHeaderRowDef="viewData.staffColumns"/>
                                                <mat-row *matRowDef="let row;columns: viewData.staffColumns" />
                                                
                                                <tr class="mat-row no-data" *matNoDataRow>
                                                    <td class="mat-cell" [attr.colspan]="viewData.staffColumns?.length">No staff data</td>
                                                </tr>
                                            </mat-table>

                                        </div>
                                        <mat-paginator
                                            [length]="vm.totalRecords"
                                            [pageSize]="vm.pageSize"
                                            [pageSizeOptions]="[25, 50, 100, 500, 1000]"
                                            [pageIndex]="vm.pageIndex"
                                            showFirstLastButtons
                                            (page)="pageStaff($event)"/>

                                    }

                                </div>
                            </mat-expansion-panel>
                        </div>

                    } @else {

                        <div class="mat-accordion">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <span>Staff (Loading...)</span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                    <div class="sub-section">
                                        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                    </div>
                            </mat-expansion-panel>
                        </div>

                    }

                }

                @if (viewData.studentCategory) {

                    @if (studentVM$ | async; as vm) {

                        <div class="mat-accordion">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>

                                    <mat-panel-title>
                                        <span>Students (</span>

                                        @if (studentLoading()) {

                                            <span>Loading...</span>

                                        } @else {

                                            <span [innerText]="vm.totalRecords | number"></span>

                                        }

                                        <span>)</span>
                                    </mat-panel-title>

                                </mat-expansion-panel-header>
                                <div class="sub-section">
                                    
                                    @if (studentLoading()) {

                                        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>

                                    } @else {

                                        <div class="scrollinator">
                                        
                                            <mat-table [dataSource]="vm.data ?? []">

                                                @for (col of viewData.studentCategory.fields;track col) {

                                                    <ng-container [matColumnDef]="strip(col.key)">
                                                        <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                                        <mat-cell *matCellDef="let item">
                                                            {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                                        </mat-cell>
                                                    </ng-container>

                                                }

                                                <mat-header-row *matHeaderRowDef="viewData.studentColumns"/>
                                                <mat-row *matRowDef="let row;columns: viewData.studentColumns" />
                                                
                                                <tr class="mat-row no-data" *matNoDataRow>
                                                    <td class="mat-cell" [attr.colspan]="viewData.studentColumns?.length">No student data</td>
                                                </tr>
                                            </mat-table>

                                        </div>
                                        <mat-paginator
                                            [length]="vm.totalRecords"
                                            [pageSize]="vm.pageSize"
                                            [pageSizeOptions]="[25, 50, 100, 500, 1000]"
                                            [pageIndex]="vm.pageIndex"
                                            showFirstLastButtons
                                            (page)="pageStudents($event)"/>
                                        
                                    }

                                </div>
                            </mat-expansion-panel>
                        </div>
                        
                    } @else {

                        <div class="mat-accordion">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <span>Students (Loading...)</span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                    <div class="sub-section">
                                        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
                                    </div>
                            </mat-expansion-panel>
                        </div>

                    }

                }

            </div>
        } @else {

            <div style="width: 80%; margin: 5% auto;">
                <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
            </div>
            
        }

    }
</div>

} @else {

    <div style="width: 80%; margin: 5% auto;">
        <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
    </div>
    
}

